import { Serializable } from '@core/models';
import { OutOfMenuDay } from './outOfMenuDay';

export class OutOfMenu extends Serializable {
  constructor(startDate, endDate, days, title) {
    super();
    this.startDate = startDate;
    this.endDate = endDate;
    this.days = days;
    this.title = title;
  }

  serialize() {
    return {};
  }

  titleHtml() {
    return `<h1 style="text-align: center; ">${this.title}</h1>`;
  }

  styleHtml() {
    return `<style>
            @media print
                {
                    .no-print, .no-print *
                    {
                        display: none !important;
                    }
                }
            .background-print{
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    background-color: white;
                }
            </style>`;
  }

  backgroundPrintHtml() {
    return '<div class="no-print background-print"></div>';
  }

  serializeHtml() {
    return `<html>${this.styleHtml()}${this.backgroundPrintHtml()}${this.titleHtml()}${this.days.map((day) => day.serializeHtml()).join('')}</html>`;
  }

  printWindow(windowRef) {
    if (windowRef && !windowRef.closed) {
      const serializedHtml = this.serializeHtml();
      windowRef.document.write(serializedHtml);
      windowRef.print();
      windowRef.close();
    }
  }

  static toInstance(props = {}) {
    const days = OutOfMenuDay.toInstanceList(props.days);
    return new OutOfMenu(props.start_date, props.end_date, days, props.title);
  }
}
